import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material"
import {
  AddCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  MoreVertOutlined,
  PauseCircleOutlined,
} from "@mui-symbols-material/w300"
import React, { useState } from "react"

import { CompanyStatus } from "@/graphql/codegen/graphql"

interface PaymentActionsMenuProps {
  paymentTypeStatus?: CompanyStatus
  onDelete: () => void
  onEditPaymentType?: () => void
  onEditBankDetails?: () => void
  onDeactivate?: () => void
  onActivate?: () => void
}

const PaymentActionsMenu: React.FC<PaymentActionsMenuProps> = ({
  paymentTypeStatus,
  onDelete,
  onEditPaymentType,
  onEditBankDetails,
  onDeactivate,
  onActivate,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleEditPaymentType = () => {
    onEditPaymentType?.()
    handleClose()
  }

  const handleEditBankDetails = () => {
    onEditBankDetails?.()
    handleClose()
  }

  const handleDelete = () => {
    onDelete()
    handleClose()
  }

  return (
    <>
      <IconButton onClick={handleClick} color='primary' aria-label='payment method actions'>
        <MoreVertOutlined className='size-5 text-primary' />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {onEditPaymentType && (
          <MenuItem onClick={handleEditPaymentType}>
            <ListItemIcon>
              <EditOutlined className='size-5 text-primary' />
            </ListItemIcon>
            <ListItemText primary='Edit Payment Type' />
          </MenuItem>
        )}
        {onEditBankDetails && (
          <MenuItem onClick={handleEditBankDetails}>
            <ListItemIcon>
              <EditOutlined className='size-5 text-primary' />
            </ListItemIcon>
            <ListItemText primary='Edit Bank Details' />
          </MenuItem>
        )}
        {paymentTypeStatus === CompanyStatus.Inactive && onActivate && (
          <MenuItem onClick={() => onActivate()}>
            <ListItemIcon>
              <AddCircleOutlined className='size-5 text-primary' />
            </ListItemIcon>
            <ListItemText primary='Activate' />
          </MenuItem>
        )}
        {paymentTypeStatus !== CompanyStatus.Inactive && onDeactivate && (
          <MenuItem onClick={() => onDeactivate()}>
            <ListItemIcon>
              <PauseCircleOutlined className='size-5 text-primary' />
            </ListItemIcon>
            <ListItemText primary='Deactivate' />
          </MenuItem>
        )}
        <MenuItem onClick={() => handleDelete()}>
          <ListItemIcon>
            <DeleteOutlined className='size-5 text-primary' />
          </ListItemIcon>
          <ListItemText primary='Delete' />
        </MenuItem>
      </Menu>
    </>
  )
}

export default PaymentActionsMenu
